import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { makeAPI } from '../../../utils/api';
import { actions as errorActions } from '../../../redux/ui/error';

export function useSignConsentAPI({ makeUrl, payload }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const signConsent = useCallback((consent = {}, userId, outcomeTitle) => {
    const { id, version } = consent;
    setLoading(true);

    return makeAPI({
      url: makeUrl(id),
      method: 'post',
      headers: {
        platform: 'P_WEB',
      },
      data: {
        user_consent_info: {
          id,
          version,
          accepted: true,
          user_id: userId,
          ...(outcomeTitle ? { outcome_title: outcomeTitle } : {}),
        },
        ...payload,
      },
    })
      .then(res => {
        setLoading(false);
        return res;
      })
      .catch(err => {
        setLoading(false);
        dispatch(errorActions.update({ id: 'errors.common' }));
        throw err;
      });
  }, []);

  return {
    loading,
    signConsent,
  };
}



// WEBPACK FOOTER //
// ./src/components/VirtualRoom/SignConsent/useSignConsentAPI.js